import React, { useState } from "react";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

import { SNOOP_NUMBER, BARGE_NUMBER, WHISPER_NUMBER } from "../../../../config";

const AgentsFreeOut = props => {
  const initialState = () => {
    return {
      playing: false,
      key: "",
      buttonName: "",
    };
  };

  const [playingStatus, setPlayingStatus] = useState(initialState);

  const testCall = (dest, key, buttonName, headerContent) => {
    if (playingStatus.playing) {
      if (
        playingStatus.key === key &&
        playingStatus.buttonName === buttonName
      ) {
        props.stopCall();
        setPlayingStatus({
          playing: false,
          key: "",
          buttonName: "",
        });
      } else {
        props.stopCall();
        props.startCall(dest, headerContent);
        setPlayingStatus({
          playing: true,
          key,
          buttonName,
        });
      }
    } else {
      props.stopCall();
      props.startCall(dest, headerContent);
      setPlayingStatus({
        playing: true,
        key,
        buttonName,
      });
    }
  };

  const tableBody = () => {
    const ret = props.agents_available_list_out.map((agent, idx) => {
      const key = agent.id + agent.sip_id;
      const agentSipID = agent.sip_id;
      const status = agent.status;

      const currentQueue =
        "active_queue" in agent ? agent.active_queue : agent.queues[0];
      return (
        <tr key={agent.id}>
          <td>{idx + 1}</td>
          <td>
            {agent.name} ({agent.queue_type})
          </td>
          <td>
            {agent.status} ({agent.status_time})
          </td>
          <td>{agent.logged_in_time}</td>
          <td>{currentQueue}</td>
          <td>{agent.missed_calls}</td>
          <td>
            <Button
              variant={
                playingStatus.playing &&
                playingStatus.key === key &&
                playingStatus.buttonName === "snoop"
                  ? "warning"
                  : "primary"
              }
              size="sm"
              onClick={() => testCall(SNOOP_NUMBER, key, "snoop", agentSipID)}
              disabled={
                props.sipConnectionStatus.registered && status === "Talking"
                  ? false
                  : true
              }
            >
              {playingStatus.playing &&
              playingStatus.key === key &&
              playingStatus.buttonName === "snoop"
                ? "Stop"
                : "Snoop"}
            </Button>
            <Button
              variant={
                playingStatus.playing &&
                playingStatus.key === key &&
                playingStatus.buttonName === "barge"
                  ? "warning"
                  : "primary"
              }
              size="sm"
              onClick={() => testCall(BARGE_NUMBER, key, "barge", agentSipID)}
              disabled={
                props.sipConnectionStatus.registered && status === "Talking"
                  ? false
                  : true
              }
            >
              {playingStatus.playing &&
              playingStatus.key === key &&
              playingStatus.buttonName === "barge"
                ? "Stop"
                : "Barge"}
            </Button>
            <Button
              variant={
                playingStatus.playing &&
                playingStatus.key === key &&
                playingStatus.buttonName === "whisper"
                  ? "warning"
                  : "primary"
              }
              size="sm"
              onClick={() =>
                testCall(WHISPER_NUMBER, key, "whisper", agentSipID)
              }
              disabled={
                props.sipConnectionStatus.registered && status === "Talking"
                  ? false
                  : true
              }
            >
              {playingStatus.playing &&
              playingStatus.key === key &&
              playingStatus.buttonName === "whisper"
                ? "Stop"
                : "Whisper"}
            </Button>
          </td>
        </tr>
      );
    });

    return ret;
  };

  return (
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>#</th>
          <th>Agent</th>
          <th>Status(Duration)</th>
          <th>Logged In(Duration)</th>
          <th>Queue Name</th>
          <th>Missed Calls</th>
          <th>Snoop/Barge/Whisper</th>
        </tr>
      </thead>
      <tbody>{tableBody()}</tbody>
    </Table>
  );
};

const mapStateToProps = state => {
  return {
    agents_available_list_out:
      state.rmqReducer.agents.agents_available_list_out,
    user: state.authReducer.user,
    sipConnectionStatus: state.dashboardReducer.sip_connection_status,
  };
};
export default connect(mapStateToProps, {})(AgentsFreeOut);
